import * as React from "react";
import type { SVGProps } from "react";
const SvgHelpCircleSolidIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="help_circle_solid_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 981.333c259.2 0 469.333-210.133 469.333-469.333S771.2 42.667 512 42.667 42.667 252.8 42.667 512 252.8 981.333 512 981.333zm7.168-638.762a85.333 85.333 0 0 0-94.89 55.765 42.667 42.667 0 1 1-80.513-28.288 170.667 170.667 0 0 1 331.648 56.832c0 65.28-48.426 108.416-82.986 131.456a343.723 343.723 0 0 1-71.936 36.224l-1.494.512-.426.17-.214.043h-.042l-.086.043a42.667 42.667 0 0 1-27.008-80.939l.683-.213a250.88 250.88 0 0 0 15.53-6.272c10.54-4.693 24.235-11.605 37.675-20.565 29.44-19.627 44.971-40.448 44.971-60.502v-.042a85.333 85.333 0 0 0-70.912-84.224zm-53.675 382.976a42.667 42.667 0 0 1 42.667-42.667h.427a42.667 42.667 0 1 1 0 85.333h-.427a42.667 42.667 0 0 1-42.667-42.666z"
    />
  </svg>
);
export default SvgHelpCircleSolidIcon;
